export const SUPERSET_SLICE_NAME = '@@superset';
